import { render, staticRenderFns } from "./SectionButtonComponent.vue?vue&type=template&id=0ae00d89"
import script from "./SectionButtonComponent.vue?vue&type=script&lang=js"
export * from "./SectionButtonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports